import React, { useState, useRef } from "react";
import Slider from "react-slick";
import { Container } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./Experience.module.css"; // Import CSS
import ImageSlider from "./ImageSlider/ImageSlider";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/autoplay";
// Custom CSS

const images = [
  {
    src: "https://swiperjs.com/demos/images/nature-1.jpg",
    title: "Mountain View",
  },
  {
    src: "https://swiperjs.com/demos/images/nature-2.jpg",
    title: "Calm Forest",
  },
  {
    src: "https://swiperjs.com/demos/images/nature-3.jpg",
    title: "Sunny Beach",
  },
  {
    src: "https://swiperjs.com/demos/images/nature-4.jpg",
    title: "Green Hills",
  },
  {
    src: "https://swiperjs.com/demos/images/nature-5.jpg",
    title: "Foggy Morning",
  },
  {
    src: "https://swiperjs.com/demos/images/nature-6.jpg",
    title: "Desert Sunset",
  },
];

export default function Experience() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className={styles.containerExperience}>
      <div className={styles.boxExperience}>
        <h3 className={styles.experiencetext}>Our Finest Experiences</h3>
      </div>
      <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>

      <ImageSlider />
      </div>

      {/* <div
        className={styles.mobileSliderExperience}
      >
        <Swiper
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView="auto"
          loop={true}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 200,
            modifier: 3,
            slideShadows: false,
          }}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3000, // ms
            disableOnInteraction: false, // keeps autoplay after drag/swipe
          }}
          modules={[EffectCoverflow, Pagination, Autoplay]}
          className={styles.swiperContainer}
        >
          {images.map((item, index) => (
            <SwiperSlide
              key={index}
              className={`${styles.slide} ${styles.slideCustom} ${
                index === activeIndex ? styles.activeSlide : ""
              }`}
            >
              <div className={styles.slideContent}>
                <img src={item.src} alt={item.title} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div> */}
    </div>
  );
}

const style = {
  slide: (bg) => ({
    background: bg,
    height: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: "2rem",
  }),
};
